import RecoveryCode from "./RecoveryCode";
import { useUser } from "@/redux/user";
import React, { useState } from "react";
import Input from "../../components/ui/input-form";
import { FaCheck } from "react-icons/fa";
import { validatePassword, validateConfirmPassword } from "../../util/validate";
import styles from "./styles/Settings.module.css";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import { errorCodes } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import { Button } from "@/components/ui/button";

export default function Password() {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  const { hasRecoveryCode } = useUser();
  const [currentPasswordError, setCurrentPasswordError] = useState(null);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState(null);
  const [passwordUpdated, setPasswordUpdated] = useState(false);

  function updatePassword() {
    const passwordErr =
      hasRecoveryCode &&
      (!password || password.length < 8 || password.length > 128)
        ? "ERROR_ACCOUNT_PASSWORD"
        : validatePassword(password);
    const confirmErr = validateConfirmPassword(password, confirmPassword);

    setCurrentPasswordError(null);
    setPasswordError(passwordErr);
    setConfirmPasswordError(confirmErr);

    if (!passwordErr && !confirmErr) {
      setLoadingBar(true);
      api
        .post("/password/update", { password, currentPassword })
        .then((response) => {
          setCurrentPassword("");
          setPassword("");
          setConfirmPassword("");
          setPasswordUpdated(true);
        })
        .catch((err) => {
          if (hasRecoveryCode && err?.response?.status === 403)
            setCurrentPasswordError("ERROR_CURRENT_PASSWORD");
          else
            setPasswordError(
              err?.response?.status === 429
                ? "ERROR_AUTH_RATE_LIMIT"
                : errorCodes.ERROR_GENERAL
            );
        })
        .then(() => {
          setLoadingBar(false);
        });
    }
  }

  return (
    <div className={styles.body}>
      <div className={styles.title}>
        {settingsT("Update password")}{" "}
        {passwordUpdated && (
          <div className={styles.doneCheck}>
            <FaCheck />
          </div>
        )}
      </div>
      <div className={styles.form}>
        {hasRecoveryCode && (
          <Input
            id="current-account-password"
            autoComplete="current-password"
            className={styles.margin}
            value={currentPassword}
            errorCode={currentPasswordError}
            onChange={(e) => setCurrentPassword(e.target.value)}
            label={settingsT("currentAccountPassword")}
            type="password"
          />
        )}
        <Input
          className={styles.margin}
          id="update-account-password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          label={t("Password")}
          type="password"
          errorCode={passwordError}
        />

        <Input
          className={styles.margin}
          id="confirm-account-password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          label={t("Password again")}
          type="password"
          errorCode={confirmPasswordError}
        />

        <Button
          size="wide"
          variant="default"
          onClick={() => updatePassword()}
          disabled={passwordUpdated}
        >
          {passwordUpdated ? t("Done") : t("Save")}
        </Button>
        <RecoveryCode />
      </div>
    </div>
  );
}
